import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFilter1: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="filter-1, sort"><path d="M20.25 3.75H3.75V8L9.75 14V21L14.25 20V14L20.25 8V3.75Z" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconFilter1;
